export default "__VITE_ASSET__0c2edc5e__"